// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2RJjW","footer":"ModalFilter_footer__2zOg8"};